export default __webpack_public_path__ + "static/color-picker-text-light-6fd99ccde52833b1e543aace2ceac252.png";